<template>
    <div>



        <!-- F043Dmdi-radiobox-blank
F043Emdi-radiobox-marked -->
        <sg-items-block name="Передавать контактную информацию поставщикам услуг для получения фискального чека">



            <v-list-item :disabled="!hasPhone" @click.stop="selectNewValue('phone')">

                <v-list-item-icon class="mr-4">
                    <v-icon :color="hasPhone ? 'primary' : ''">

                        {{!hasPhone ? 'mdi-lock' : (contactForProvider == 'phone' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank')}}


                    </v-icon>
                </v-list-item-icon>

                <v-list-item-content class="d-block">
                    <v-list-item-title>Номер телефона</v-list-item-title>
                    <v-list-item-subtitle v-if="!hasPhone">Не указан номер телефона</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            
                <v-divider style="margin-left: 56px;"/>

            <v-list-item :disabled="!hasEmail" @click.stop="selectNewValue('email')">

                <v-list-item-icon class="mr-4">
                    <v-icon :color="hasEmail ? 'primary' : ''">
                        {{!hasEmail ? 'mdi-lock' : (contactForProvider == 'email' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank')}}
                    </v-icon>
                </v-list-item-icon>


                <v-list-item-content class="d-block">
                    <v-list-item-title>Адрес электронной почты</v-list-item-title>
                    <v-list-item-subtitle v-if="!hasEmail">Не указана электронная почта</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            
                     <v-divider style="margin-left: 56px;"/>

            <v-list-item @click.stop="selectNewValue('')">

                <v-list-item-icon class="mr-4">
                    <v-icon color="primary">

                        {{!contactForProvider ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'}}
                    </v-icon>
                </v-list-item-icon>


                <v-list-item-content class="d-block">
                    <v-list-item-title>Не передавать</v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

        </sg-items-block>

        <v-alert v-if="!hasPhone" class="text-body-2 my-2"  type="info" text :icon="false">
            Для того, чтобы иметь возможность получать чек на телефон необходим указать номер телефона
            <div class="d-flex justify-end mt-2">
                <v-btn color="primary" small outlined :to="{name: 'wv-settings-phone-edit'}">Указать</v-btn>
            </div>
        </v-alert>

        <v-alert v-if="!hasEmail"  class="text-body-2 my-2" type="info" text :icon="false">
            Для того, чтобы иметь возможность получать чек на электронную почту необходимо указать адрес
            <div class="d-flex justify-end mt-2">
                <v-btn color="primary" small outlined :to="{name: 'wv-settings-email-edit'}">Указать</v-btn>
            </div>
        </v-alert>



        <sg-nav-back-btn class="mt-3"/>

    </div>
</template>

<script>
    import settingsMixin from './settingsMixin'

    export default {
        mixins: [settingsMixin],

        computed: {

            contactForProvider() {
                return this.userInfo.settings.contactForProvider
            }
        },
        data() {
            return {
                loading: false
            }
        },
        methods: {
            selectNewValue(newValue) {

                if (this.contactForProvider == newValue) return

                if (this.loading) return


                this.loading = true

                /*           this.$store.dispatch('settings/SET_SETTING', {
                        settingName: 'contactForProvider',
                        newValue: newValue
                    })
                    .finally(() => {
                        this.loading = false
                    })
 */
                this.changeSettings('contactForProvider', newValue)
                    .finally(() => {
                        this.loading = false
                    })

            }
        }

    }
</script>

<style>

</style>